import type { TConfig } from './FirebaseConfigFetcher';

import { FirebaseConfigFetcher } from './FirebaseConfigFetcher';

export enum EFeatureValue {
  'ENABLED' = 'enabled',
  'DISABLED' = 'disabled',
  'UNSET' = 'unset',
}

export const EFeatureName = {
  CACHE_API_SERVICE: 'CACHE_API_SERVICE',
  CHECKOUT_NON_ACCEPTANCE_PAYMENT: 'CHECKOUT_NON_ACCEPTANCE_PAYMENT',
  COMBO: 'COMBO',
  ADD_BUTTON_ONLY: 'ADD_BUTTON_ONLY',
  SENTRY: 'SENTRY',
  LOCALE: 'LOCALE',
  PRODUCT_PAYMENT_DOLYAME: 'PRODUCT_PAYMENT_DOLYAME',
  PRODUCT_BANNER: 'PRODUCT_BANNER',
  SBER_PROMO: 'SBER_PROMO',
  NEW_RATES: 'NEW_RATES',
  PROMO_IMAGE_BLOCK: 'PROMO_IMAGE_BLOCK',
  NOTIFICATION_POPUP: 'NOTIFICATION_POPUP',
} as const;

export type TFeatureName = (typeof EFeatureName)[keyof typeof EFeatureName];

export const getPromiseWith: <T>(flag: T) => () => Promise<T> = (flag) => () =>
  Promise.resolve(flag);

/*
Returns config value from Firefase config by path
@param {...string} path - Path to the desired value (rest argument)
@returns {boolean} result - Returns boolean value as feature flag from Firebase
*/
const getConfigByPath =
  (...path: string[]) =>
  () =>
    FirebaseConfigFetcher.getConfig().then((config: TConfig) => {
      let result: any = config;

      path.forEach((key) => {
        result = result[key];
      });
      return result as boolean;
    });

export const FeatureFlagsBase: Record<TFeatureName, () => Promise<boolean>> = {
  [EFeatureName.ADD_BUTTON_ONLY]: getConfigByPath('product_buy_button', 'enabled'),
  [EFeatureName.CHECKOUT_NON_ACCEPTANCE_PAYMENT]: getConfigByPath(
    'checkout_non_acceptance_payment'
  ),
  [EFeatureName.CACHE_API_SERVICE]: getPromiseWith(true),
  [EFeatureName.COMBO]: getConfigByPath('combo_items'),
  [EFeatureName.SENTRY]: getConfigByPath('sentry_enabled'),
  [EFeatureName.LOCALE]: getConfigByPath('change_language_enabled'),
  [EFeatureName.PRODUCT_PAYMENT_DOLYAME]: getConfigByPath('pdp_payment_dolyame', 'enabled'),
  [EFeatureName.PRODUCT_BANNER]: getConfigByPath('pdp_marketing_banner_enabled_web'),
  [EFeatureName.SBER_PROMO]: getConfigByPath('sber_promo'),
  [EFeatureName.NEW_RATES]: getConfigByPath('new_rates'),
  [EFeatureName.PROMO_IMAGE_BLOCK]: getConfigByPath('promo_image_block'),
  [EFeatureName.NOTIFICATION_POPUP]: getConfigByPath('notification_popup')
};
